import React, { useState, useEffect } from 'react';
import masaLogo from '../Assets/MasaLogo.png';
import styles from './SalesMyRequests.module.css';
import { getSalesUserRequests } from '../api/salesRequestApi';

const SalesMyRequests = () => {
  const [requests, setRequests] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    getSalesUserRequests()
      .then(response => setRequests(response.data))
      .catch(error => {
        console.error('Error fetching sales user requests:', error);
        setErrorMessage('Failed to fetch your requests. Please try again.');
      });
  }, []);

  return (
    <main className={styles.requestsManagement}>
      <header className={styles.header}>
        <img
          loading="lazy"
          src={masaLogo}
          className={styles.logo}
          alt="Dashboard Logo"
        />
        <h1 className={styles.title}>My Sales Requests</h1>
      </header>
      <div className={styles.explanationText}>
        <p>
          Here you can view all of your submitted sales requests. Track their status and see if they have been accepted, rejected, or if the submission date has been changed.
        </p>
      </div>
      {errorMessage && (
        <div className={styles.errorBanner}>{errorMessage}</div>
      )}
      <section className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Product</th>
              <th>Sort</th>
              <th>Color</th>
              <th>Action</th>
              <th>Quantity</th>
              <th>Submission Date</th>
              <th>Status</th>
              <th>Manager Notes</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request._id}>
                <td>{request._id}</td>
                <td>{request.product}</td>
                <td>{request.sortName}</td>
                <td>{request.color}</td>
                <td>{request.action}</td>
                <td>{request.quantity}</td>
                <td>{new Date(request.submissionDate).toLocaleDateString()}</td>
                <td>{request.status}</td>
                <td>{request.managerResponse?.notes || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </main>
  );
};

export default SalesMyRequests;
